import React, { ReactElement } from "react";
import { Help, Mail } from "@mui/icons-material";
import { AppBar, Toolbar, Grid, IconButton, CircularProgress } from "@mui/material";
import PqLogo from "./pqLogo";
import TopMenu from "./topMenu";
import UserInfo from "./userInfo";
import { useAppSelector } from "../../app/hooks";
import { QueryStatus } from "@reduxjs/toolkit/query";

export default function TopBar(): ReactElement {
  const isLoading = useAppSelector((state) => {
    return (
      Object.values(state.api.queries).some((query) => {
        return query && query.status === QueryStatus.pending;
      }) ||
      Object.values(state.api.mutations).some((mutation) => {
        return mutation && mutation.status === QueryStatus.pending;
      })
    );
  });

  return (
    <AppBar>
      <Toolbar variant="dense">
        <PqLogo />
        <TopMenu />
        <Grid item xs />
        {isLoading && <CircularProgress sx={{ color: "white" }} size={24} />}
        <IconButton href={import.meta.env.VITE_HELP ?? ""} target="_blank" sx={{ color: "white" }}>
          <Help />
        </IconButton>
        <IconButton href={"mailto:" + import.meta.env.VITE_HELP_MAIL} sx={{ color: "white" }}>
          <Mail />
        </IconButton>
        <UserInfo />
      </Toolbar>
    </AppBar>
  );
}
